export default __webpack_public_path__ + "static/media/person.11807604.svg";